import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const TagIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 16, height = 16, viewBox = '0 0 16 16' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81227 15.5394C9.50521 15.8465 9.12474 16 8.67084 16C8.21694 16 7.83646 15.8465 7.52941 15.5394L0.480601 8.49061C0.333751 8.34376 0.216938 8.17021 0.130163 7.96996C0.0433876 7.76971 0 7.55611 0 7.32916V1.602C0 1.16145 0.156863 0.784314 0.470588 0.470588C0.784314 0.156863 1.16145 0 1.602 0H7.32916C7.55611 0 7.76971 0.0433876 7.96996 0.130163C8.17021 0.216938 8.34376 0.333751 8.49061 0.480601L15.5394 7.54944C15.8465 7.85649 16 8.23363 16 8.68085C16 9.12808 15.8465 9.50521 15.5394 9.81227L9.81227 15.5394ZM8.67084 14.418L14.398 8.69086L7.32916 1.602H1.602V7.32916L8.67084 14.418ZM3.60451 4.80601C3.93826 4.80601 4.22194 4.68919 4.45557 4.45557C4.68919 4.22194 4.80601 3.93826 4.80601 3.60451C4.80601 3.27076 4.68919 2.98707 4.45557 2.75344C4.22194 2.51982 3.93826 2.403 3.60451 2.403C3.27076 2.403 2.98707 2.51982 2.75344 2.75344C2.51982 2.98707 2.403 3.27076 2.403 3.60451C2.403 3.93826 2.51982 4.22194 2.75344 4.45557C2.98707 4.68919 3.27076 4.80601 3.60451 4.80601Z"
        fill={color}
      />
    </svg>
  );
};

export default TagIcon;
